<div class="flex items-center justify-center min-h-screen bg-gray-100 dark:bg-gray-900 px-4">
    <div class="w-full max-w-2xl bg-white dark:bg-gray-800 shadow-lg rounded-2xl p-6">
        <ui-label [tag]="ELabelType.TITLE" [type]="EAlert.DARK">Redefinição de senha</ui-label>
        <br>
        <div *ngIf="!isAuthenticated">
            <ui-step-progress [steps]="steps" [currentStep]="step" (stepChange)="nextStep($event)">
            </ui-step-progress>
        </div>
        <ui-dynamic-form *ngIf="fields.length > 0" (valueChange)="submit($event)" [withBorder]="true" [useSteps]="false"
            [inList]="true" [finalSubmit]=" isAuthenticated || step == 2 ? 'Atualizar' : 'Próximo'" [fields]="fields">
        </ui-dynamic-form>

        <br>

        <div class="text-center mt-4">
            <ui-label *ngIf="step == 1 && correctCode" [tag]="ELabelType.PARAGRAPH" [type]="EAlert.INFO">Seu código já
                foi confirmado.</ui-label>
        </div>

    </div>
</div>